export default "__VITE_ASSET__DvGPSbe8__"